import { v4 as uuidv4 } from 'uuid';

export const blockInitialValues = {
  Paragraph: {
    id: uuidv4(),
    type: 'Paragraph',
    data: {
      paragraph: '',
    },
  },
  Heading: {
    id: uuidv4(),
    type: 'Heading',
    data: {
      level: 1,
      paragraph: '',
    },
  },
  List: {
    id: uuidv4(),
    type: 'List',
    data: {
      style: 'unordered',
      items: [{ id: uuidv4(), text: '' }],
    },
  },
  Image: {
    id: uuidv4(),
    type: 'Image',
    data: {
      file: { url: '' },
      caption: '',
    },
  },
  Code: {
    id: uuidv4(),
    type: 'Code',
    data: {
      code: '',
    },
  },
  Quote: {
    id: uuidv4(),
    type: 'Quote',
    data: {
      paragraph: '',
      caption: '',
    },
  },
};

export const createNewBlock = (type: keyof typeof blockInitialValues): any => ({
  id: uuidv4(),
  type,
  data:
    type === 'Heading'
      ? {
          level: 1,
          header: '',
          paragraph: null,
          items: null,
          file: null,
          code: null,
          withBorder: null,
          withBackground: null,
          stretched: null,
          caption: null,
          style: null,
        }
      : {
          paragraph: '',
          header: null,
          level: null,
          items: null,
          file: null,
          code: null,
          withBorder: null,
          withBackground: null,
          stretched: null,
          caption: null,
          style: null,
        },
});
